import React, { useEffect, useMemo, useRef, forwardRef, useCallback } from 'react';
import { SectionList, FlatList, DeviceEventEmitter } from 'react-native';
import PropTypes from 'prop-types';
import ExposureManager from './exposureManager';
import AdapterConfig from './utils/AdapterConfig';
import TraceInit from './TraceInit';

function TraceListContainer(
  {
    traceId = '',
    componentName = 'SectionList',
    onViewableItemsChanged,
    traceObj,
    pageName,
    pageId,
    eventName = 'willAppear',
    statSend = { getParam: () => ({ spm: '' }), visible: () => {}, touch: () => {}, view: () => {} },
    ...args
  },
  ref,
) {
  const Components = componentName === 'SectionList' ? SectionList : FlatList;

  const visibleData = TraceInit.getInstance().config[traceId];
  const lowerType = AdapterConfig.getTraceOperation(traceId);
  const isTrace = (lowerType && lowerType.includes('visible')) || false;
  const exposure = useMemo(() => (isTrace ? new ExposureManager(statSend) : null), [isTrace]);
  const _instance = useRef(pageId).current;
  const _pageName = useRef(pageName).current;

  useEffect(() => {
    const handler = (e) => {
      if (e.instance === _instance) {
        exposure && exposure.onPageBack();
      }
    };
    DeviceEventEmitter.addListener(eventName, handler);
    return () => {
      DeviceEventEmitter.removeListener(eventName, handler);
      exposure && exposure.onPageUnmount();
    };
  }, []);

  // SectionList的items变化 items的曝光
  const onItemsChanged = useCallback(
    ({ viewableItems, changed }) => {
      try {
        if (onViewableItemsChanged) {
          onViewableItemsChanged({ viewableItems, changed });
        }
        const curViewableItems = getParseList(viewableItems);
        const curChangedItems = getParseList(changed);
        if (curChangedItems.length === 0) {
          return;
        }
        const curInfo = {
          changed: curChangedItems,
          viewableItems: curViewableItems,
        };

        exposure && exposure.onViewableItemChanged(curInfo);
      } catch (e) {
        console.log('TraceListContainer onItemsChanged error:', e);
      }
    },
    [onViewableItemsChanged],
  );

  const getParseList = (arr = []) => {
    if (arr.length === 0) {
      return null;
    }
    const newArr = [];
    arr.forEach((item) => {
      const parseFunName = item.section?.type ? `getParse_${item.section?.type}` : 'getParse';
      const curItem = visibleData[parseFunName]?.func(item, visibleData, { pageName: _pageName, traceObj }) || [];

      if (Array.isArray(curItem)) {
        curItem.forEach((e) => {
          newArr.push(e);
        });
      } else {
        newArr.push(curItem);
      }
    });
    return newArr;
  };

  return <Components ref={ref} {...args} onViewableItemsChanged={onItemsChanged} />;
}

TraceListContainer.propTypes = {
  traceId: PropTypes.string,
  componentName: PropTypes.string, // 曝光的组件名称 SectionList还是FlatList，默认是SectionList
  onViewableItemsChanged: PropTypes.func, // 原先SectionList和FlatList的onViewableItemsChanged，如果不需要在这里做处理，可以不传
  traceObj: PropTypes.object, // 可扩充字段, 除了list中的数据源意外单独需要上报的参数，会传递给config中的func
  pageName: PropTypes.string, // b位
  pageId: PropTypes.number, // 页面的instanceId, 解决二次曝光的问题
  eventName: PropTypes.string, // 二次曝光事件的名称
  statSend: PropTypes.object, // 具体发送打点的工具
};

export default forwardRef(TraceListContainer);
